export { default } from "./useDestroyConfigMutation";
